
import { useRouteData } from "@bcm-dev/bcms-vite";
import React from "react";

import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import LeftColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/LeftColumnContainer";
import RightColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/RightColumnContainer";
import SuccessNotificationView from "compid/shared/views/Notifications/SuccessNotificationView";
import { Autopay } from "model";
import { BillerActivityWidget, BillerDetailsWidget } from "../..";
import BillerDetailsEditConfirmation from "../BillerDetailsEditConfirmation";
import "./styles.css";

/**
 * @function BillerDetailsDesktopView
 * @return {React.Component}
 * @exported true
 * @description This is the component that displays the desktop layout for the BillerDetailsPage.
 */
export default function BillerDetailsDesktopView(props) {
  const { route } = useRouteData();
  // Replace the state so it doesn't persist on a page reload
  window.history.replaceState({}, document.title);
  const markedBillAsPaid = route === null ? false : route.markedBillAsPaid;
  let successMessage = markedBillAsPaid ? "You have successfully marked your bill as paid." : undefined;
  const hasRouteData = route ? true : false;
  
  if(hasRouteData) {
    if(route.autopayDeleted === "true") {
      successMessage = Autopay.getAutopaySuccessMessage(route);
    }
  }

  return(
    <div className="biller-details-desktop-view">
      <PageLayoutContainer>
        <LeftColumnContainer>
          <BillerDetailsEditConfirmation />
          { successMessage !== undefined && <SuccessNotificationView message={ successMessage } showClose={ false }/> }
          <BillerDetailsWidget />
        </LeftColumnContainer>

        <RightColumnContainer>
          <BillerActivityWidget />
        </RightColumnContainer>
      </PageLayoutContainer>
    </div>
  );
}